import styled from "styled-components";
import { MainWrapper, MainHeader, MainHeading, MainBodyText, OutlineButton, MainSection, } from "../../components/01_config/MainStyles";
import { sizes } from "../../components/01_config/Sizes";
import { Link } from "react-router-dom";

const Wrapper = styled(MainWrapper)`

`

const Header = styled(MainHeader)`
`

const TitleWrapper = styled(MainSection)`
    // display: flex;
    // justify-content: space-between;
    // flex-wrap: wrap;
    // gap: 30px;
    // @media(max-width: 800px) {
    //     justify-content: center;
    // }
    padding: 0 ${sizes.sections_mob_marginsides};
    @media(max-width: 800px) {
        flex-direction: column;
    }
`

const Title = styled(MainHeading)`

`

const CurrentLessonButton = styled(Link)`
    // position: relative;
    // margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    width: 240px;
    height: 70px;
    font-size: 1.1rem;
    border: #D34E4E solid 4px;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0);
    color: black;
    // margin-right: ${sizes.sections_mob_marginsides};
    cursor: pointer;
    &:active {
        transform: translate(2px, 2px)
    }
    @media(max-width: 800px) {
        width: 240px;
        height: 70px;
        margin-right: 0;
    }
`


const MyRoadmapWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${sizes.marginsections}; 
`


const MainText = styled(MainBodyText)`
    padding: 0 ${sizes.sections_mob_marginsides};
    z-index: 20;
    text-align: justify;
`
const CardsText = styled(MainText)`
    white-space: pre-line;
`
const CardsList = styled.li`
    white-space: pre-line;
    list-style: disc;
`

export { Wrapper, MyRoadmapWrapper, Header, CurrentLessonButton, TitleWrapper, Title, MainText, CardsText, CardsList }